// src/data/cityQuotes.js
// Random quotes shown during train door transition per city

export const CITY_QUOTES = {
  paris: [
    { text: "Paris is always a good idea.", author: "Audrey Hepburn" },
    { text: "Though you may leave Paris, Paris never really leaves you.", author: "Janice Macleod" },
    { text: "Just wandering the city is entertainment.", author: "Wes Anderson" },
    { text: "When good Americans die, they go to Paris.", author: "Oscar Wilde" },
  ],
  nyc: [],
  london: [
    { text: "London is a city of contradiction and chaos, but that's what makes it so thrilling and alive.", author: "Emma Watson" },
    { text: "The man who can dominate a London dinner-table can dominate the world.", author: "Oscar Wilde" },
    { text: "Living a posh life in Kensington.", author: null },
    { text: "Getting my vintage on in Camden Town.", author: null },
    { text: "Lost in a sea of clothes at Primark.", author: null },
    { text: "Last seen: Strolling around Oxford Street.", author: null },
    { text: "If you need me, I'll be on the Piccadilly line.", author: null },
    { text: "The fog was so thick we mist our tour.", author: null },
  ],
  milan: [],
  berlin: [],
  madrid: [],
}

export function getRandomQuote(city) {
  const quotes = CITY_QUOTES[city] || []
  if (!quotes.length) return null
  return quotes[Math.floor(Math.random() * quotes.length)]
}
